export enum HoursMode {
  WORKED    = 'worked',
  SCHEDULED = 'scheduled',
  OVERRIDE  = 'override',
}

export interface NetVarianceRow {
  id: string;
  orgID: string;
  period_start: string;
  period_end: string;
  date: string;
  is_stat_holiday: boolean;
  employee_id: string | null;
  employee_name: string;
  shift_id: string | null;
  schedule_id: string | null;
  clocked_in_role: string;
  scheduled_role: string;
  role_flag: boolean;
  start: string | null;
  end: string | null;
  clock_in: string | null;
  clock_out: string | null;
  hours_scheduled: number;
  hours_worked: number;
  variance: number;
  hours_mode: HoursMode;
  override: number | null;
  reason: string | null;
  overridden_by: string | null;
}

export interface ActiveFilter {
  id: string;
  field: string;
  operator: string;
  value: string;
}

export interface OverrideData {
  hours: number;
  reason: string;
}

export interface VarianceUpdate {
  id: string;
  hours_mode: HoursMode;
  override: number | null;
  reason: string | null;
}

export const FILTER_FIELDS: { key: string; label: string; fieldType: 'string' | 'number' }[] = [
  { key: 'employee_name',   label: 'Employee',        fieldType: 'string' },
  { key: 'scheduled_role',  label: 'Scheduled Role',  fieldType: 'string' },
  { key: 'clocked_in_role', label: 'Shift Role',      fieldType: 'string' },
  { key: 'hours_scheduled', label: 'Hours Scheduled', fieldType: 'number' },
  { key: 'hours_worked',    label: 'Hours Worked',    fieldType: 'number' },
];

export const STRING_OPERATORS = ['=', '!=', 'contains'] as const;
export const NUMBER_OPERATORS = ['=', '!=', '>', '<', '>=', '<='] as const;

export function computeNetHours(row: NetVarianceRow): number {
  let selected: number;
  if (row.hours_mode === HoursMode.OVERRIDE && row.override !== null) {
    selected = row.override;
  } else if (row.hours_mode === HoursMode.SCHEDULED) {
    selected = row.hours_scheduled;
  } else {
    selected = row.hours_worked;
  }
  return selected - (selected > 5 ? 0.5 : 0);
}

export function applyFilters(rows: NetVarianceRow[], filters: ActiveFilter[]): NetVarianceRow[] {
  if (filters.length === 0) return rows;
  return rows.filter(row =>
    filters.every(f => {
      const raw = row[f.field as keyof NetVarianceRow];
      const val = String(raw ?? '').toLowerCase();
      const fval = f.value.toLowerCase();
      const numVal = parseFloat(val);
      const numFval = parseFloat(fval);
      const isNumeric = isFinite(numVal) && isFinite(numFval);
      switch (f.operator) {
        case '=':        return isNumeric ? numVal === numFval : val === fval;
        case '!=':       return isNumeric ? numVal !== numFval : val !== fval;
        case 'contains': return val.includes(fval);
        case '>':        return numVal > numFval;
        case '<':        return numVal < numFval;
        case '>=':       return numVal >= numFval;
        case '<=':       return numVal <= numFval;
        default:         return true;
      }
    })
  );
}
